import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Compass, Home, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SiteFooter } from "@/components/SiteFooter";
import PageMeta from "@/components/PageMeta";

const suggestions = [
  { to: "/coin-reviewer", label: "AI Coin Reviewer" },
  { to: "/undervalued-gems", label: "Undervalued Gems" },
  { to: "/research", label: "Research" },
  { to: "/how-toss-works", label: "How TOSS Works" },
  { to: "/track-record", label: "Track Record" },
  { to: "/contact", label: "Contact" },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <PageMeta
        title="Page Not Found — GoToCoin"
        description="The page you're looking for doesn't exist. Explore GoToCoin's AI coin reviewer, undervalued gems and Australian crypto research instead."
        path="/404"
        noIndex
      />

      <main className="flex-1 container mx-auto px-4 py-20 max-w-2xl flex flex-col items-center text-center">
        <div className="w-16 h-16 rounded-2xl bg-primary/10 border border-primary/30 flex items-center justify-center mb-6">
          <Compass className="w-8 h-8 text-primary" aria-hidden="true" />
        </div>

        <p className="font-mono text-sm uppercase tracking-[0.3em] text-muted-foreground">Error 404</p>
        <h1 className="mt-3 text-4xl md:text-5xl font-bold tracking-tight">This page doesn't exist</h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          The link may be broken or the page may have moved. Nothing is wrong with your account or the
          market data — just this address.
        </p>

        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Button asChild size="lg" className="gap-2">
            <Link to="/">
              <Home className="w-4 h-4" /> Back to home
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="gap-2">
            <Link to="/coin-reviewer">
              <Search className="w-4 h-4" /> Review a coin
            </Link>
          </Button>
        </div>

        <div className="mt-12 w-full">
          <h2 className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Popular pages</h2>
          <div className="flex flex-wrap gap-2 justify-center">
            {suggestions.map(s => (
              <Link
                key={s.to}
                to={s.to}
                className="px-3 py-1.5 rounded-full border border-border/60 bg-card/50 text-sm text-muted-foreground hover:text-foreground hover:border-primary/40 transition-colors"
              >
                {s.label}
              </Link>
            ))}
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default NotFound;
